export function PendingPaymentsSkeleton() {
    return (
      <div className="bg-[#F1F1F1] rounded-lg px-5 py-4 mx-auto space-y-3 animate-pulse mb-4">
        {[1, 2].map((_, i) => (
          <div key={i} className="flex items-center justify-between gap-4 mb-3">
            <div className="flex flex-col gap-2 w-full">
              <div className="h-4 w-32 bg-gray-300 rounded" />
              <div className="h-4 w-24 bg-gray-200 rounded" />
            </div>
            <div className="h-4 w-16 bg-gray-300 rounded" />
          </div>
        ))}
      </div>
    );
  }
  
  export function ActiveMedicationsSkeleton() {
    return (
      <div className="bg-[#F1F1F1] rounded-lg px-5 py-4 mx-auto space-y-3 animate-pulse mb-4">
        {[1, 2].map((_, i) => (
          <div key={i} className="flex items-center justify-between gap-4 mb-3">
            <div className="flex flex-col gap-2 w-full">
              <div className="h-4 w-32 bg-gray-300 rounded" />
              <div className="h-4 w-24 bg-gray-200 rounded" />
            </div>
            <div className="h-4 w-16 bg-gray-300 rounded" />
          </div>
        ))}
      </div>
    );
  }
  
  export function ProcessingMedicationsSkeleton() {
    return (
      <div className="bg-[#F1F1F1] rounded-lg px-5 py-4 mx-auto space-y-3 animate-pulse mb-4">
        {[1, 2].map((_, i) => (
          <div key={i} className="flex items-center justify-between gap-4 mb-3">
            <div className="flex flex-col gap-2 w-full">
              <div className="h-4 w-32 bg-gray-300 rounded" />
              <div className="h-4 w-24 bg-gray-200 rounded" />
            </div>
            <div className="h-4 w-16 bg-gray-300 rounded" />
          </div>
        ))}
      </div>
    );
  }
  
  export function PastMedicationsSkeleton() {
    return (
      <div className="bg-[#F1F1F1] rounded-lg px-5 py-4 mx-auto space-y-3 animate-pulse mb-4">
        {[1, 2].map((_, i) => (
          <div key={i} className="flex items-center justify-between gap-4 mb-3">
            <div className="flex flex-col gap-2 w-full">
              <div className="h-4 w-32 bg-gray-300 rounded" />
              <div className="h-4 w-24 bg-gray-200 rounded" />
            </div>
            <div className="h-4 w-16 bg-gray-300 rounded" />
          </div>
        ))}
      </div>
    );
  }
  
  export function MedicationHistorySkeleton() {
    return (
      <div className="bg-[#F1F1F1] rounded-lg px-5 py-4 mx-auto space-y-3 animate-pulse mb-4">
        {[1, 2, 3].map((_, i) => (
          <div key={i} className="flex items-center gap-4 mb-3">
            <div className="h-4 w-32 bg-gray-300 rounded" />
            <div className="h-4 w-24 bg-gray-200 rounded" />
          </div>
        ))}
      </div>
    );
  }